import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { StatusPill, TrustChips, EmptyState, InlineLoader } from "@/components/shared";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Megaphone, PlusCircle, Pencil, Eye } from "lucide-react";

export default function OrganizerCampaigns() {
  const [campaigns, setCampaigns] = useState(null);

  useEffect(() => {
    api.get("/campaigns/mine").then((r) => setCampaigns(r.data)).catch(() => setCampaigns([]));
  }, []);

  if (!campaigns) return <InlineLoader label="Loading campaigns" />;

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-ff-blue sm:text-3xl">My Campaigns</h1>
        <Button asChild className="bg-ff-action font-semibold text-white hover:bg-ff-actionDark">
          <Link to="/start-a-fundraiser" data-testid="campaigns-new"><PlusCircle className="mr-2 h-4 w-4" /> New Fundraiser</Link>
        </Button>
      </div>

      {campaigns.length === 0 ? (
        <EmptyState icon={Megaphone} title="No campaigns yet"
          message="Start your first fundraiser and submit it for review."
          action={<Button asChild className="bg-ff-action text-white"><Link to="/start-a-fundraiser">Start a fundraiser</Link></Button>}
          testid="campaigns-empty" />
      ) : (
        <div className="overflow-hidden rounded-xl border border-ff-border bg-white shadow-sm" data-testid="campaigns-table">
          <Table>
            <TableHeader>
              <TableRow className="bg-[#F3F4F6]">
                <TableHead>Campaign</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Raised</TableHead>
                <TableHead className="text-right">Donors</TableHead>
                <TableHead className="text-right">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {campaigns.map((c) => (
                <TableRow key={c.id} data-testid={`campaign-row-${c.slug}`}>
                  <TableCell>
                    <div className="font-heading font-bold text-ff-blue">{c.title}</div>
                    <div className="text-xs text-ff-medium">{c.category}</div>
                  </TableCell>
                  <TableCell><StatusPill status={c.status} /></TableCell>
                  <TableCell className="text-right font-semibold text-ff-blue">{money(c.amount_raised)}</TableCell>
                  <TableCell className="text-right">{c.donor_count || 0}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button asChild size="sm" variant="outline" className="border-ff-blue text-ff-blue">
                        <Link to={`/organizer/campaign-builder/${c.id}`} data-testid={`edit-${c.slug}`}><Pencil className="h-3.5 w-3.5" /></Link>
                      </Button>
                      <Button asChild size="sm" variant="outline" className="border-ff-border">
                        <Link to={`/organizer/campaign-status/${c.id}`} data-testid={`status-${c.slug}`}><Eye className="h-3.5 w-3.5" /></Link>
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
